import "./NX5_MonitorVitalDataMobileView.scss";
import monitorOfflineIcon from "../../common/icons/svg/patient-monitor-offline.svg";
import { MONITOR_PARAMETER } from "../../common/constant/common-constants";
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import MonitorChart from "../MonitorChart/MonitorChart";


const NX5_MonitorVitalDataMobileView = ({ props }) => {

    if (!props?.monitorHeartBeatData?.isConnected) {
        return (
            <div className="offline-mobile-view">
                <img
                    className="not-in-use-image-mobile-view"
                    src={monitorOfflineIcon}
                    alt="Monitor Offline"
                />
                <h2 className="not-in-use-text-mobile-view">
                    Monitor is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.
                </h2>
            </div>
        );
    }

    const hr = props.vitalData_ECG?.[MONITOR_PARAMETER.HR];
    const rr = props.vitalData_ECG?.[MONITOR_PARAMETER.RR];
    const spo2 = props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2];
    const pr = props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE];
    const temp1 = props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1];
    const temp2 = props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_2];
    const nibpSys = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC];
    const nibpDia = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_DIASTOLIC];
    const nibpMean = props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_MEAN];

    const fmt = (v, digits) => {
        if (v == null || v === "") return "- -";
        return typeof digits === "number" ? Number(v).toFixed(digits) : v;
    };

    const renderLimits = (paramData) => {
        const high = paramData?.alarm_limit?.[1];
        const low = paramData?.alarm_limit?.[0];
        return (
            <div className="nx5-vital-tile-limits">
                <span className="nx5-limit-high">{high ?? "--"}</span>
                <span className="nx5-limit-low">{low ?? "--"}</span>
            </div>
        );
    };

    const renderSubRow = (label, value, paramData) => (
        <div className="nx5-vital-subrow">
            <span className="nx5-subrow-label">{label}</span>
            <span className="nx5-subrow-value">{value}</span>
            {renderLimits(paramData)}
        </div>
    );

    return (
        <div className="nx5-monitor-vitals-container-mobile-view">
            <div className="nx5-monitor-vitals-mobile-view-alarms">
                <DevicesTab
                    activeVitalDevice={props.activeVitalDevice}
                    bedId={props.bedId}
                    alarmData={props.alarmData}
                    handleSeeAllAlarms={props.handleSeeAllAlarms}
                />
            </div>

            {!props.monitoringVitalsView ? (
                <div className="nx5-monitor-vitals-mobile-view-graphs">
                    <MonitorChart bedId={props.bedId} />
                </div>
            ) : (

                <div className="nx5-monitor-vitals-mobile-view-body">
                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-hr">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title">
                                    <span className="nx5-vital-tile-label">HR</span>
                                    <span className="nx5-vital-tile-unit">beats/min</span>
                                </div>
                                {renderLimits(hr)}
                            </div>
                            <div className="nx5-vital-tile-value">{fmt(hr?.value)}</div>
                        </div>

                        <div className="nx5-vital-tile nx5-tile-pr">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title">
                                    <span className="nx5-vital-tile-label">PR</span>
                                    <span className="nx5-vital-tile-unit">beats/min</span>
                                </div>
                                {renderLimits(pr)}
                            </div>
                            <div className="nx5-vital-tile-value">{fmt(pr?.value)}</div>
                        </div>
                    </div>

                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-rr">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title">
                                    <span className="nx5-vital-tile-label">RR</span>
                                    <span className="nx5-vital-tile-unit">b/min</span>
                                </div>
                                {renderLimits(rr)}
                            </div>
                            <div className="nx5-vital-tile-value">{fmt(rr?.value)}</div>
                        </div>

                        <div className="nx5-vital-tile nx5-tile-spo2">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title">
                                    <span className="nx5-vital-tile-label">SPO<sub>2</sub></span>
                                    <span className="nx5-vital-tile-unit">%</span>
                                </div>
                                {renderLimits(spo2)}
                            </div>
                            <div className="nx5-vital-tile-value">{fmt(spo2?.value)}</div>
                        </div>
                    </div>

                    <div className="nx5-vital-tile-row">
                        <div className="nx5-vital-tile nx5-tile-temp nx5-tile-composite">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title nx5-vital-tile-title-inline">
                                    <span className="nx5-vital-tile-label">TEMP</span>
                                    <span className="nx5-vital-tile-unit">°C</span>
                                </div>
                            </div>
                            <div className="nx5-vital-tile-subrows">
                                {renderSubRow("T1", fmt(temp1?.value, 1), temp1)}
                                {renderSubRow("T2", fmt(temp2?.value, 1), temp2)}
                            </div>
                        </div>

                        <div className="nx5-vital-tile nx5-tile-nibp nx5-tile-composite">
                            <div className="nx5-vital-tile-header">
                                <div className="nx5-vital-tile-title nx5-vital-tile-title-inline">
                                    <span className="nx5-vital-tile-label">NIBP</span>
                                    <span className="nx5-vital-tile-unit">mmHg</span>
                                </div>
                            </div>
                            <div className="nx5-vital-tile-subrows">
                                {renderSubRow("Sys", fmt(nibpSys?.value), nibpSys)}
                                {renderSubRow("Dia", fmt(nibpDia?.value), nibpDia)}
                                {renderSubRow("Mean", fmt(nibpMean?.value), nibpMean)}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
    );
};

export default NX5_MonitorVitalDataMobileView;
